export const parkingMarkerDataSelector = ({parkingMarkerData}) => parkingMarkerData